<script setup lang="ts">
const emits = defineEmits(['search'])
const modelValue = defineModel<string>()
</script>

<template>
  <FInput v-model="modelValue" type="text" name="q" placeholder="Vyhledat v článcích" :show-prefix-divider="false" @keyup.enter="emits('search')">
    <template #prefix>
      <UnoIcon h-18px w-18px i-fubex-search mt="3px" ml-5px />
    </template>
    <template #suffix>
      <FButton size="md" variant="outline" name="search" w-full @click.stop="emits('search')">
        Hledat
      </FButton>
    </template>
  </FInput>
</template>
